import { comparisonPlatforms } from "@/mocks/comparisons";

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight">
            Porównanie Platform <span className="text-primary-600">Spreadsheet</span>
          </h2>
          <p className="text-foreground-600 mt-3 text-sm max-w-xl mx-auto leading-relaxed">
            Zobacz, jak Kakobuy Spreadsheet wypada na tle konkurencji. Porównaj funkcje, zalety i wybierz najlepszą opcję dla siebie.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {comparisonPlatforms.map((platform) => (
            <div
              key={platform.name}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300"
            >
              <div className="flex items-center gap-2 mb-4">
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${
                        i < platform.rating
                          ? "ri-star-fill text-accent-500"
                          : "ri-star-line text-foreground-300"
                      }`}
                    ></i>
                  ))}
                </div>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {platform.name}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed mb-4">
                {platform.description}
              </p>
              <ul className="space-y-1.5">
                {platform.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2 text-xs text-foreground-700">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}